import React, { Suspense } from 'react';
import { InputBlockHome } from './inputBlockHome';
import { useScoreModel } from '../../model/context/scoreModelContext';
import { ScoreModelEditor } from './modules/scoreModelEditor/scoreModelEditor';
import { LinearProgress, Stack } from '@mui/material';

const HomePage = () => {
  const { scoreModel } = useScoreModel();
  return (
    <Stack direction={'row'} spacing={0} height="inherit">
      <Suspense fallback={<LinearProgress />}>
        <InputBlockHome scoreModel={scoreModel} />
      </Suspense>
      <ScoreModelEditor
        scoreModel={
          scoreModel ?? {
            scoreModelId: NaN,
            name: 'New Score Model',
            active: true,
            policyRules: []
          }
        }
      />
    </Stack>
  );
};

export default HomePage;
